import React, { useState, useEffect, useRef } from 'react';
import { dataLocalMaisDias } from './dataParcelaPolicy';
import { itemForaDoAdiantamento, situacaoAdiantamento, seloItemAdiantamento, totalCreditado, valorPelaSelecao } from './adiantamentoSolicitacaoPolicy';
import { contadorGrupo, faltaDoComplemento, itemBloqueado, itemLiberadoParaComplemento, pendenciasComplemento, selecaoEhComplemento } from './complementoAdiantamentoPolicy';
import ErpTemplate from '../../components/ErpTemplate';
import { FaArrowLeft, FaMoneyBillWave, FaUpload, FaDownload, FaHistory, FaChevronDown, FaChevronRight, FaUserTie, FaPen, FaSync, FaFileInvoice, FaTimes, FaPlus, FaTrashAlt, FaEllipsisV, FaCheck } from 'react-icons/fa';
import { FinCheck, FinField, FinInput, FinPercentual, FinTextarea, FinValor } from '../../components/FinField';
import api from '../../services/api';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import { moeda, virgulaPonto, ACEITE_RECIBO, erroSeNaoForPdf } from '../../util/util';
import FechamentoExteriorResumo from './FechamentoExteriorResumo';
import { resumirFechamentoExterior } from './fechamentoExteriorPolicy';
import { toast } from 'react-toastify';
import { podeRegistrarSolicitacaoAdiantamento, podeRenegociarAdiantamento, MENSAGEM_SEM_PERMISSAO_RENEGOCIAR } from './adiantamentoPermissaoPolicy';
import { avisoPoEvento, pendenciasSolicitacaoAdiantamento } from './adiantamentoRequisitosPolicy';
import { useSetFullBreadcrumbTrail } from '../../context/BreadcrumbContext';
import AdiantamentoClientePagou from '../../components/Financeiro/AdiantamentoClientePagou';
import { podeMarcarClienteJaPagou } from '../../components/Financeiro/adiantamentoClientePagouPolicy';
import '../../css/financeiro-parcela-pagar.css';
import { ESCOLHAS_ETAPA, ETAPA_VIGENTE, itensNaEtapa, percentualDoOrcamento, temItemEmOutraMoeda, textoQuebraPorMoeda, textoTaxasItem, textoValorNaMoeda, totalTaxas, valoresAdiantamentoPorSubitem } from './adiantamentoMoedaPolicy';

const fmtDatetime = (str) => {
    if (!str) return null;
    try {
        const d = new Date(str);
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    } catch { return null; }
};

const fmtDate = (str) => {
    if (!str) return null;
    try {
        const d = new Date(str + 'T00:00:00');
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    } catch { return null; }
};

const SIMBOLO_MOEDA = { real: 'R$', dolar: 'US$', euro: '€', iene: '¥', libra: '£', dolarcad: 'C$' };
const simboloMoeda  = (moeda) => SIMBOLO_MOEDA[moeda] || 'R$';

// Nome legível do fornecedor do subitem. O backend às vezes devolve o nome no
// padrão "codigo - nome - nomefantasia" — fica só a última parte não-vazia.
const nomeFornecedorLimpo = (forn) => {
    if (!forn) return null;
    let nome = forn.nomefantasia || forn.nome || ('Fornecedor #' + forn.id);
    if (nome && nome.includes(' - ')) {
        const partes = nome.split(' - ').map(p => p.trim()).filter(Boolean);
        nome = partes[partes.length - 1] || nome;
    }
    return nome;
};

const TIPOS_CONFIG = [
    { id: 'adiantamento', label: 'Adiantamento', sub: 'Fluxo padrão dentro do prazo', icon: '💰', cor: '#0d6efd' },
    { id: 'urgente',     label: 'Pagamento urgente', sub: 'Antes da próxima janela · exige diretoria', icon: '⚡', cor: '#dc3545' },
    { id: 'novo',        label: 'Novo adiantamento', sub: 'Verba anterior esgotada · com comprovantes', icon: '🔄', cor: '#ffc107' },
];

export default function SolicitarAdiantamento({ match }) {
    const token   = localStorage.getItem('token');
    const location = useLocation();
    const history  = useHistory();
    const setFullTrail = useSetFullBreadcrumbTrail();

    const orcamentoId          = match?.params?.id;
    const params               = new URLSearchParams(location.search);
    const idEvento             = params.get('evento');
    const renegociarParcelaId  = params.get('renegociar'); // ID da parcela a renegociar (modo edição)
    const modoRenegociar       = !!renegociarParcelaId;

    // ─── Estado principal ──────────────────────────────────────────────────
    const [orcamento,    setOrcamento]    = useState(null);
    // Requisitos do cliente (anexo obrigatorio, campos obrigatorios) vindos do
    // servidor. O front NAO decide mais isso — ver ClienteRequisitoService.
    const [requisitos,   setRequisitos]   = useState(null);
    const [carregando,   setCarregando]   = useState(true);
    const [nomeEvento,   setNomeEvento]   = useState('');
    const [nomeCliente,  setNomeCliente]  = useState('');

    // Itens
    const [itens,                    setItens]                    = useState([]);
    // D-0126: todos os itens elegíveis com o valor cheio das 4 escolhas de etapa; `itens` = os que têm valor na escolhida.
    const [itensBase,                setItensBase]                = useState([]);
    const [etapaValor,               setEtapaValor]               = useState(ETAPA_VIGENTE);
    const [totalSelecionado,         setTotalSelecionado]         = useState(0);
    const [expandedGrupos,           setExpandedGrupos]           = useState({});
    const [currentAdiantamentoItemIds, setCurrentAdiantamentoItemIds] = useState([]); // IDs do adiantamento sendo renegociado

    // Campos do formulário
    const [tipoAdiantamento,      setTipoAdiantamento]      = useState('adiantamento');
    const [valorSolicitadoManual, setValorSolicitadoManual] = useState('');
    // % sobre a soma dos itens selecionados (Adriana, Inter 14/10): enquanto digita, o % é o dela; fora disso é derivado do valor.
    const [percentualDigitado, setPercentualDigitado] = useState(null);
    const [dataAdiantamento,      setDataAdiantamento]      = useState('');
    const [justificativa,         setJustificativa]         = useState('');

    // Abas
    const [abaAtiva, setAbaAtiva] = useState('registrar'); // 'registrar' | 'lista' | 'recibos'

    // Aba "Adiantamentos" — accordeon por fornecedor (default aberto; false = recolhido)
    const [fornecedoresAbertos, setFornecedoresAbertos] = useState({});

    // Edição de adiantamento existente (Tab 2)
    const [editandoParcelaId,  setEditandoParcelaId]  = useState(null);
    const [editValor,          setEditValor]           = useState('');
    const [editVencimento,     setEditVencimento]      = useState('');
    const [editJustificativa,  setEditJustificativa]   = useState('');
    const [editSalvando,       setEditSalvando]        = useState(false);

    // Solicitar NF ao Fornecedor (adiantamentos creditados)
    const [solicitarNFModal,   setSolicitarNFModal]    = useState(null);
    const [emailsSolicitarNF,  setEmailsSolicitarNF]   = useState(['']);
    const [enviandoNF,         setEnviandoNF]          = useState(false); // guard duplo clique

    // Excluir pedido de adiantamento (modal padrão fin-pp)
    const [excluirModal,       setExcluirModal]        = useState(null);
    const [motivoExcluir,      setMotivoExcluir]       = useState('');
    const [excluindoAdt,       setExcluindoAdt]        = useState(false); // guard duplo clique

    // Histórico de recibos
    const [valorRecibo,              setValorRecibo]              = useState('');
    const [observacaoRecibo,         setObservacaoRecibo]         = useState('');
    const [loginSapRecibo,           setLoginSapRecibo]           = useState('');
    const [dataPrevisaoPagamento,    setDataPrevisaoPagamento]    = useState('');
    const [arquivoRecibo,            setArquivoRecibo]            = useState(null);
    const [enviandoRecibo,           setEnviandoRecibo]           = useState(false); // guard duplo clique
    const [enviandoNFUpload,         setEnviandoNFUpload]         = useState({}); // { [parcelaId]: bool } — upload de NF pelo operador
    const [sheetAdt,                 setSheetAdt]                 = useState(null); // { adt, actions } — action-sheet (menu ⋮) da linha
    const [enviandoSolicitacao,      setEnviandoSolicitacao]      = useState(false); // guard duplo clique (registrar/renegociar)
    const arquivoReciboRef = useRef(null);

    // Campos específicos por cliente
    const [loginRequisitante,  setLoginRequisitante]  = useState('');
    const [codigoSap,          setCodigoSap]          = useState('');
    // "Adiantamento já feito" (D-0120): cliente já pagou fora; só organiza o Financeiro.
    const [clienteJaPagou,     setClienteJaPagou]     = useState(false);
    const [propostaArquivo,    setPropostaArquivo]    = useState(null);
    const [propostaEnviando,   setPropostaEnviando]   = useState(false);
    const propostaRef = useRef(null);

    // Dados do evento (auto-preenchidos)
    const [eventoNumeroOi,     setEventoNumeroOi]     = useState('');
    const [eventoCentroCusto,  setEventoCentroCusto]  = useState('');
    const [eventoIdentificacao,setEventoIdentificacao]= useState('');
    const [eventoLink,         setEventoLink]         = useState('');
    const [eventoData,         setEventoData]         = useState('');
    const [eventoDataFim,      setEventoDataFim]      = useState('');
    const [eventoPos,          setEventoPos]          = useState([]);
    const [eventoResponsavel,  setEventoResponsavel]  = useState('');

    // ─── Carregamento ──────────────────────────────────────────────────────
    useEffect(() => {
        if (!orcamentoId) {
            history.replace('/orcamento' + (idEvento ? `?idEvento=${idEvento}` : ''));
            return;
        }
        carregarOrcamento();
    }, [orcamentoId, renegociarParcelaId]); // eslint-disable-line react-hooks/exhaustive-deps

    // Recarregado tambem depois do upload, porque `tem_anexo`/`pode_enviar` mudam.
    const carregarRequisitos = () => {
        api({ method: 'get', action: `/orcamento/${orcamentoId}/requisitosCliente`, token })
            .then(r => setRequisitos(r.data.data))
            .catch(() => setRequisitos(null));   // falhar aqui nao trava a tela: o servidor barra no envio
    };

    const carregarOrcamento = async () => {
        setCarregando(true);
        try {
            const response = await api({ method: 'get', action: `/orcamento/${orcamentoId}`, token });
            const orc = response.data.data;
            setOrcamento(orc);
            carregarRequisitos();

            const nomeEv = orc?.evento?.nome || orc?.Evento?.nome || '';
            const nomeCl = orc?.evento?.cliente?.nomefantasia || orc?.evento?.cliente?.nome
                        || orc?.Evento?.Cliente?.nomefantasia || orc?.Evento?.Cliente?.nome || '';
            setNomeEvento(nomeEv);
            setNomeCliente(nomeCl);

            // Campos do evento para exibição nos detalhes por cliente
            const ev = orc?.evento || orc?.Evento || {};
            setEventoNumeroOi(ev?.numeroOi || ev?.numero_oi || '');
            setEventoCentroCusto(ev?.centroCusto || '');
            setEventoIdentificacao(ev?.identificacao || '');
            setEventoLink(ev?.link || '');
            setEventoData(ev?.data || '');
            setEventoDataFim(ev?.dataFim || ev?.data_fim || '');
            setEventoPos(ev?.p_os || ev?.POs || ev?.pos || []);  // JSON retorna p_os (snake_case)
            setEventoResponsavel(ev?.responsavel_nome || '');

            // Pré-preencher campos salvos anteriormente
            const det = orc?.AdiantamentoDetalhes || orc?.adiantamento_detalhes || null;
            if (det) {
                setLoginRequisitante(det.login_requisitante || '');
                setCodigoSap(det.codigo_sap || '');
            }

            if (nomeEv) {
                setFullTrail([
                    { path: `/evento?idEvento=${idEvento}`, label: nomeEv },
                    { path: `/orcamento?idEvento=${idEvento}`, label: 'Orçamentos' },
                    { path: location.pathname + location.search, label: 'Solicitar Adiantamento' },
                ]);
            }

            // Constrói lista de itens elegíveis
            const itensComAdiantamento  = orc.itensComAdiantamento || [];
            const adiantamentosPorItem  = orc.adiantamentosPorItem || {};
            const itensFora             = orc.itensForaAdiantamento || [];
            // D-0117: cada item na moeda real dele e em R$ pelo câmbio da etapa. D-0126: R$ = valor cheio (com as taxas
            // do exterior, sem FEE) calculado pela API, nas 4 escolhas de etapa (a do fornecedor ou uma só para todos).
            const valoresPorEscolha = {};
            ESCOLHAS_ETAPA.forEach((e) => { valoresPorEscolha[e.valor] = valoresAdiantamentoPorSubitem(orc, e.valor); });
            const lista = [];
            (orc.orcamentoitem || []).forEach((item, idxItem) => {
                const nomeItem = item.produto?.nome || `Item ${idxItem + 1}`;
                (item.subitem || []).forEach((subitem, idxSub) => {
                    // FEE da Agência é receita da Access: não entra em adiantamento (130 FEE AGÊNCIA, Rafael 08/10;
                    // grupo 130 - AGÊNCIA e demais fees da agência, Rafael 20/10). A API recusa também.
                    if (itemForaDoAdiantamento({ subitem, grupo: item, itensFora })) return;
                    const valoresDoItem = {};
                    ESCOLHAS_ETAPA.forEach((e) => {
                        const info = valoresPorEscolha[e.valor][String(subitem.id)];
                        if (info) valoresDoItem[e.valor] = info;
                    });
                    if (Object.keys(valoresDoItem).length > 0) {
                        lista.push({
                            id: subitem.id,
                            itemId: item.id,
                            nomeItem,
                            nomeSubitem: subitem.produto?.nome || `Subitem ${idxSub + 1}`,
                            // O adiantamento é pedido PARA um fornecedor — a lista
                            // agrupa por ele (pedido Rafael 2026-08-04)
                            fornecedorNome: nomeFornecedorLimpo(subitem.fornecedor),
                            valoresPorEscolha: valoresDoItem, // valor/moeda/câmbio/etapa entram por itensNaEtapa
                            selecionado: false,
                            // "Não creditado" também prende o item (a API recusa; o caminho é Renegociar).
                            temAdiantamento: itensComAdiantamento.includes(subitem.id) || !!adiantamentosPorItem[String(subitem.id)]?.nao_creditado,
                            adiantamentoInfo: adiantamentosPorItem[String(subitem.id)] || null,
                        });
                    }
                });
            });

            // Modo renegociação: pré-seleciona itens do adiantamento atual e libera edição
            if (modoRenegociar && renegociarParcelaId) {
                try {
                    const respAdt = await api({
                        method: 'get',
                        action: `/financeiroParcela/itensAdiantamento/${renegociarParcelaId}`,
                        token,
                    });
                    const adtItens  = respAdt.data.data?.itens || [];
                    const adtIds    = adtItens.map(i => String(i.id));
                    const parcelaAtual = respAdt.data.data?.parcela || {};
                    setCurrentAdiantamentoItemIds(adtIds);

                    // Pré-popula valor atual do adiantamento
                    if (parcelaAtual.valor) {
                        setValorSolicitadoManual(
                            String(parseFloat(parcelaAtual.valor).toFixed(2)).replace('.', ',')
                        );
                    }

                    // Recria lista: itens do adiantamento atual ficam selecionáveis (selecionado=true, temAdiantamento=false)
                    // Itens de OUTRO adiantamento continuam bloqueados
                    const listaRenegociar = lista.map(i => ({
                        ...i,
                        selecionado: adtIds.includes(String(i.id)),
                        temAdiantamento: !adtIds.includes(String(i.id)) && i.temAdiantamento,
                        adiantamentoInfo: adtIds.includes(String(i.id)) ? null : (i.adiantamentoInfo || null),
                    }));
                    const visiveisRenegociar = itensNaEtapa(listaRenegociar, etapaValor);
                    setItensBase(listaRenegociar);
                    setItens(visiveisRenegociar);
                    const totalIni = visiveisRenegociar.filter(i => i.selecionado).reduce((s, i) => s + i.valorPreEvento, 0);
                    setTotalSelecionado(totalIni);
                } catch (errAdt) {
                    toast.error('Erro ao carregar dados do adiantamento para renegociação.');
                    setItensBase(lista);
                    setItens(itensNaEtapa(lista, etapaValor));
                }
            } else {
                setItensBase(lista);
                setItens(itensNaEtapa(lista, etapaValor));
            }
        } catch (err) {
            toast.error('Erro ao carregar orçamento: ' + (err.response?.data?.error ?? 'Erro desconhecido'));
            voltarParaOrcamentos();
        } finally {
            setCarregando(false);
        }
    };

    const voltarParaOrcamentos = () => {
        history.push('/orcamento' + (idEvento ? `?idEvento=${idEvento}` : ''));
    };

    // ─── Helpers — itens ────────────────────────────────────────────────────
    const calcularTotal = (lista) => {
        const total = lista.filter(i => i.selecionado).reduce((s, i) => s + i.valorPreEvento, 0);
        setTotalSelecionado(total);
        return total;
    };

    // Toda mudança de seleção passa aqui: Valor = soma dos selecionados e o % se recalcula
    // (Rafael 20/10 — o grupo e o "Marcar todos" não atualizavam e o Valor ficava R$ 0,00).
    // Complemento: sugere o que falta (soma dos itens daquele adiantamento − já pedido), não a soma cheia.
    const aplicarSelecao = (novos) => {
        setItens(novos);
        const total = calcularTotal(novos);
        // Complemento (21/10): sugere o que falta no adiantamento (soma dos itens dele − já pedido).
        const valor = valorPelaSelecao(total, selecaoEhComplemento(novos, tipoAdiantamento), faltaDoComplemento(novos, tipoAdiantamento));
        if (valor !== null) {
            setValorSolicitadoManual(valor);
            setPercentualDigitado(null);
        }
    };

    // D-0126: troca a etapa do valor (a do fornecedor ou uma só para todos). Leva a seleção e os selos atuais para a
    // base, refaz a lista na etapa nova (some o item sem valor nela) e o Valor acompanha a soma, como na seleção.
    const trocarEtapaValor = (nova) => {
        if (nova === etapaValor) return;
        const atuais = new Map(itens.map(i => [i.id, i]));
        const base = itensBase.map(b => {
            const a = atuais.get(b.id);
            return a ? { ...b, selecionado: a.selecionado, temAdiantamento: a.temAdiantamento, adiantamentoInfo: a.adiantamentoInfo } : b;
        });
        setItensBase(base);
        setEtapaValor(nova);
        aplicarSelecao(itensNaEtapa(base, nova));
    };

    const toggleItem = (id) => {
        aplicarSelecao(itens.map(i =>
            i.id === id && !itemBloqueado(i, tipoAdiantamento) ? { ...i, selecionado: !i.selecionado } : i
        ));
    };

    const marcarTodos = (sel) => {
        aplicarSelecao(itens.map(i => i.temAdiantamento ? i : { ...i, selecionado: sel })); // "Marcar todos" só pega itens livres
    };

    const toggleGrupo = (itensGrupo, sel) => {
        const ids = itensGrupo.filter(i => !i.temAdiantamento).map(i => i.id); // complemento é item a item
        aplicarSelecao(itens.map(i => ids.includes(i.id) ? { ...i, selecionado: sel } : i));
    };

    const toggleExpandGrupo = (gIdx) => {
        setExpandedGrupos(prev => ({ ...prev, [gIdx]: prev[gIdx] === false ? true : false }));
    };

    // ─── Helpers — recibos ──────────────────────────────────────────────────
    const obterRecibos = (orc) => {
        // 1. Recibos enviados pelo lado Eventos (tabela orcamento_recibo_adiantamento)
        const recibosEventos = orc?.RecibosAdiantamento || orc?.recibos_adiantamento || orc?.recibosAdiantamento || [];

        // 2. Recibos enviados pelo Financeiro (financeiro_parcela.arquivoreciboadiantamento)
        //    Expostos via adiantamentosDoOrcamento[].arquivo_recibo_id
        const adiantamentos = orc?.adiantamentosDoOrcamento || [];
        const recibosFinanceiro = adiantamentos
            .filter(function(a) { return !!(a.arquivo_recibo_id); })
            .map(function(a) {
                return {
                    id:          a.arquivo_recibo_id,
                    arquivo:     a.arquivo_recibo_id,
                    valor:       a.valor || 0,
                    observacao:  a.descricao || '',
                    created_at:  a.created_at || null,
                    _origem:     'financeiro',
                };
            });

        const todos = [
            ...(Array.isArray(recibosEventos) ? recibosEventos : []),
            ...recibosFinanceiro,
        ];
        if (todos.length > 0) return todos;

        // 3. Fallback legado (campo único pré-2026)
        const reciboArquivo = orc?.arquivo_recibo_adiantamento || orc?.ArquivoReciboAdiantamento || null;
        const reciboId = reciboArquivo?.id || orc?.arquivoReciboAdiantamento;
        if (!reciboId) return [];
        return [{ id: reciboId, arquivo: reciboId, valor: orc?.valorAdiantamento || 0, observacao: orc?.observacaoAdiantamento || '', created_at: null }];
    };

    const uploadRecibo = () => {
        if (enviandoRecibo) return; //envio em andamento — evita duplo clique
        if (!arquivoRecibo) { toast.error('Selecione um arquivo'); return; }
        const erroPdf = erroSeNaoForPdf(arquivoRecibo);
        if (erroPdf) { toast.error(erroPdf); return; }
        const val = virgulaPonto(valorRecibo);
        if (!val || val <= 0) { toast.error('Informe o valor do adiantamento'); return; }

        setEnviandoRecibo(true);
        const reader = new FileReader();
        reader.onload = () => {
            const uint8 = new Uint8Array(reader.result);
            const hex   = Array.from(uint8).map(b => b.toString(16).padStart(2, '0')).join('');
            api({
                method: 'post',
                action: `/orcamento/uploadReciboAdiantamento/${orcamentoId}`,
                token,
                data: {
                    valorAdiantamento: val,
                    observacaoAdiantamento: observacaoRecibo,
                    loginSap: loginSapRecibo,
                    dataPrevisaoPagamento: dataPrevisaoPagamento || null,
                    binarioArquivoRecibo: hex,
                    nomeArquivoRecibo: arquivoRecibo.name,
                },
            }).then(r => {
                toast.success('Recibo enviado com sucesso!');
                setOrcamento(r.data.data);
                setValorRecibo('');
                setObservacaoRecibo('');
                setLoginSapRecibo('');
                setDataPrevisaoPagamento('');
                setArquivoRecibo(null);
                if (arquivoReciboRef.current) arquivoReciboRef.current.value = '';
            }).catch(err => toast.error('Erro ao enviar recibo: ' + (err.response?.data?.error ?? 'Erro')))
              .finally(() => setEnviandoRecibo(false));
        };
        reader.readAsArrayBuffer(arquivoRecibo);
    };

    const removerRecibo = (reciboId) => {
        if (!window.confirm('Remover este recibo?')) return;
        api({ method: 'delete', action: `/orcamento/removerReciboAdiantamento/${reciboId}`, token })
            .then(r => { toast.success('Recibo removido!'); setOrcamento(r.data.data); })
            .catch(err => toast.error('Erro: ' + (err.response?.data?.error ?? 'Erro')));
    };

    const uploadProposta = () => {
        if (!propostaArquivo) { toast.error('Selecione um arquivo'); return; }
        setPropostaEnviando(true);
        const reader = new FileReader();
        reader.onload = () => {
            const uint8 = new Uint8Array(reader.result);
            const hex   = Array.from(uint8).map(b => b.toString(16).padStart(2, '0')).join('');
            api({
                method: 'post',
                action: `/orcamento/uploadPropostaAdiantamento/${orcamentoId}`,
                token,
                data: {
                    binarioArquivoProposta: hex,
                    nomeArquivoProposta: propostaArquivo.name,
                },
            }).then(r => {
                toast.success('Proposta enviada com sucesso!');
                carregarRequisitos();   // tem_anexo/pode_enviar mudaram
                setPropostaArquivo(null);
                if (propostaRef.current) propostaRef.current.value = '';
                // Nao recarregar o orcamento aqui: carregarOrcamento() liga o spinner
                // e remonta a lista com selecionado:false, apagando os itens que o
                // operador ja tinha marcado antes de clicar em Registrar Solicitacao.
                const arquivoProposta = r.data && r.data.data && r.data.data.arquivo;
                if (arquivoProposta) {
                    setOrcamento(o => (o ? {
                        ...o,
                        AdiantamentoDetalhes: {
                            ...(o.AdiantamentoDetalhes || {}),
                            PropostaArquivo: arquivoProposta,
                        },
                    } : o));
                }
            }).catch(err => toast.error('Erro ao enviar proposta: ' + (err.response?.data?.error ?? 'Erro')))
              .finally(() => setPropostaEnviando(false));
        };
        reader.readAsArrayBuffer(propostaArquivo);
    };

    // ─── Submit ─────────────────────────────────────────────────────────────
    const registrarSolicitacao = () => {
        if (enviandoSolicitacao) return; //envio em andamento — evita duplo clique criando N solicitações
        const selecionados = itens.filter(i => i.selecionado);
        if (selecionados.length === 0) { toast.error('Selecione pelo menos um item'); return; }
        const valorFinal = parseFloat(virgulaPonto(valorSolicitadoManual)) || totalSelecionado;
        if (valorFinal <= 0) { toast.error('Valor deve ser maior que zero'); return; }
        // Requisitos do cliente com o que esta DIGITADO (caso 16): `requisitos.pode_enviar`
        // olha os campos gravados, vazios na 1a solicitacao. A API aplica a mesma regra.
        if (pendenciasEnvio.length > 0) {
            pendenciasEnvio.forEach(msg => toast.error(msg, { autoClose: 7000 }));
            return;
        }

        setEnviandoSolicitacao(true);
        api({
            method: 'post',
            action: `/orcamento/solicitarAdiantamento/${orcamentoId}`,
            token,
            data: {
                itemIds: selecionados.map(i => i.id),
                observacao: justificativa,
                valorTotal: valorFinal,
                // D-0126: a API recalcula o valor cheio de cada item nesta etapa e grava; o que a tela mostrou vai junto
                // para ela recusar se o orçamento mudou depois que a tela carregou.
                etapa: etapaValor,
                valoresItens: Object.fromEntries(selecionados.map(i => [i.id, i.valorPreEvento])),
                tipo: tipoAdiantamento,
                dataPagamento: dataAdiantamento || null,
                justificativa,
                loginRequisitante: loginRequisitante || null,
                codigoSap: codigoSap || null,
                clienteJaPagou,
            },
        }).then(() => {
            toast.success('Solicitação registrada com sucesso!');
            voltarParaOrcamentos();
        }).catch(err => {
            toast.error('Erro: ' + (err.response?.data?.error ?? 'Erro'));
            setEnviandoSolicitacao(false);
        });
    };

    // ─── Submit — renegociação ──────────────────────────────────────────────
    const renegociarSolicitacao = () => {
        if (enviandoSolicitacao) return; //envio em andamento — evita duplo clique
        if (!dataAdiantamento) {
            toast.error('Informe a nova data de pagamento — mínimo 7 dias a partir de hoje.');
            return;
        }
        // Dia LOCAL + 7: o toISOString() (UTC) virava o dia seguinte depois das 21h (06/10).
        const minimo = dataLocalMaisDias(7);
        if (dataAdiantamento < minimo) {
            toast.error('A nova data precisa ser de no mínimo 7 dias a partir de hoje ('
                + minimo.slice(8, 10) + '/' + minimo.slice(5, 7) + '/' + minimo.slice(0, 4) + ' ou depois).');
            return;
        }
        const selecionados = itens.filter(i => i.selecionado);
        if (selecionados.length === 0) { toast.error('Selecione pelo menos um item'); return; }
        const valorFinal = parseFloat(virgulaPonto(valorSolicitadoManual)) || totalSelecionado;
        if (valorFinal <= 0) { toast.error('Valor deve ser maior que zero'); return; }
        // Requisitos do cliente. Aviso antecipado — a trava real esta no servidor.
        if (requisitos && requisitos.pode_enviar === false) {
            (requisitos.pendencias || []).forEach(msg => toast.error(msg, { autoClose: 7000 }));
            return;
        }

        setEnviandoSolicitacao(true);
        api({
            method: 'put',
            action: `/financeiroParcela/${renegociarParcelaId}/renegociar`,
            token,
            data: {
                itemIds: selecionados.map(i => i.id),
                valorTotal: valorFinal,
                // D-0126: a API refaz a foto do valor cheio dos itens nesta etapa (e recusa se o orçamento mudou).
                etapa: etapaValor,
                valoresItens: Object.fromEntries(selecionados.map(i => [i.id, i.valorPreEvento])),
                justificativa: justificativa || '',
                // Obrigatoria na renegociacao: minimo 7 dias e diferente da atual
                // (reuniao 06/08). O backend valida; aqui so evita a ida a toa.
                dataPagamento: dataAdiantamento || null,
            },
        }).then(() => {
            toast.success('Adiantamento renegociado! O financeiro será notificado.');
            voltarParaOrcamentos();
        }).catch(err => {
            // A API da renegociação responde { erro, mensagem } — antes lia só `error` e mostrava "Erro: Erro".
            const d = err.response?.data || {};
            toast.error(d.mensagem || d.message || d.error || 'Não foi possível renegociar.');
            setEnviandoSolicitacao(false);
        });
    };

    // ─── Edit adiantamento existente (Tab 2) ───────────────────────────────
    const abrirEdicaoAdt = (adt) => {
        setEditandoParcelaId(adt.parcela_id);
        setEditValor(String(parseFloat(adt.valor || 0).toFixed(2)).replace('.', ','));
        setEditVencimento(adt.vencimento || '');
        setEditJustificativa('');
    };

    const salvarEdicaoAdiantamento = () => {
        const valorNum = parseFloat(editValor.replace(',', '.'));
        if (!valorNum || valorNum <= 0) { toast.error('Informe um valor válido'); return; }
        setEditSalvando(true);
        api({
            method: 'put',
            action: `/financeiroParcela/${editandoParcelaId}/editarAdiantamento`,
            token,
            data: { valor: valorNum, vencimento: editVencimento || null, justificativa: editJustificativa },
        }).then(() => {
            toast.success('Adiantamento atualizado! O financeiro será notificado.');
            setEditandoParcelaId(null);
            carregarOrcamento();
        }).catch(err => toast.error('Erro: ' + (err.response?.data?.mensagem ?? err.response?.data?.error ?? 'Erro')))
          .finally(() => setEditSalvando(false));
    };

    // ─── Upload de NF pelo próprio operador (alternativa ao link do fornecedor) ──
    const uploadNFAdiantamento = (adt) => {
        if (enviandoNFUpload[adt.parcela_id]) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.jpg,.jpeg,.png,.xml';
        input.style.display = 'none';
        input.onchange = (e) => {
            const file = e.target.files[0];
            if (!file) return;
            setEnviandoNFUpload(prev => ({ ...prev, [adt.parcela_id]: true }));
            // O "Enviando NF..." fica no item do menu hambúrguer, que fecha ao
            // clicar — ou seja, ninguém vê. O toast é o único feedback visível
            // de que o envio começou. (react-toastify 7: sem toast.loading.)
            toast.info('Enviando nota fiscal...', { autoClose: 2500 });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('tipoArquivo', 'notafiscal');
            formData.append('modulo', 'financeiro');
            formData.append('pasta', 'notafiscal');
            axios.post(
                process.env.REACT_APP_API_URL + '/financeiroParcelaArquivo/' + adt.parcela_id,
                formData,
                { headers: { 'content-type': 'multipart/form-data', 'Authorization': 'Bearer ' + token } }
            )
                .then(() => {
                    toast.success('Nota fiscal anexada com sucesso!');
                    carregarOrcamento();
                })
                .catch((error) => {
                    toast.error('Erro ao enviar NF: ' + (error.response?.data?.error ?? 'Erro desconhecido'));
                })
                .finally(() => setEnviandoNFUpload(prev => ({ ...prev, [adt.parcela_id]: false })));
        };
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    };

    // ─── Solicitar NF ao Fornecedor (adiantamentos creditados) ─────────────
    const abrirSolicitarNF = (adt) => {
        const emailSalvo = adt.fornecedor_email || '';
        const lista = emailSalvo
            ? emailSalvo.split(',').map(function(e) { return e.trim(); }).filter(Boolean)
            : [''];
        setEmailsSolicitarNF(lista.length > 0 ? lista : ['']);
        setSolicitarNFModal(adt);
    };

    const enviarSolicitarNF = () => {
        if (enviandoNF) return; // envio em andamento — evita duplo clique
        const emails = emailsSolicitarNF.map(function(e) { return e.trim(); }).filter(Boolean);
        if (emails.length === 0) { toast.error('Adicione ao menos um e-mail.'); return; }
        if (!solicitarNFModal) return;
        setEnviandoNF(true);
        api({ method: 'put', action: '/financeiroParcela/' + solicitarNFModal.parcela_id + '/solicitarNF', token: token, data: { emails: emails } })
            .then(() => {
                toast.success('Solicitação de NF enviada ao fornecedor.');
                setSolicitarNFModal(null);
                carregarOrcamento();
            })
            .catch((err) => {
                const errMsg = (err.response && err.response.data && (err.response.data.mensagem || err.response.data.error))
                    ? (err.response.data.mensagem || err.response.data.error)
                    : 'Erro ao enviar solicitação.';
                toast.error(errMsg);
            })
            .finally(() => { setEnviandoNF(false); });
    };

    // ─── Excluir pedido de adiantamento (modal padrão fin-pp) ──────────────
    const abrirExcluirAdiantamento = (adt) => {
        setMotivoExcluir('');
        setExcluirModal(adt);
    };

    const confirmarExcluirAdiantamento = () => {
        if (excluindoAdt || !excluirModal) return; // envio em andamento — evita duplo clique
        setExcluindoAdt(true);
        api({ method: 'put', action: '/financeiroParcela/' + excluirModal.parcela_id + '/excluirAdiantamento', token: token, data: { motivo: motivoExcluir } })
            .then(() => {
                setExcluirModal(null);
                setMotivoExcluir('');
                toast.success('Pedido de adiantamento excluído.');
                carregarOrcamento();
            })
            .catch((err) => {
                toast.error('Erro ao excluir: ' + (err.response && err.response.data && err.response.data.error ? err.response.data.error : 'tente novamente'));
            })
            .finally(() => { setExcluindoAdt(false); });
    };

    // ─── Derivados ──────────────────────────────────────────────────────────
    const recibos          = orcamento ? obterRecibos(orcamento) : [];
    // "Já adiantado" = só o que o Financeiro informou como creditado; recibo sem crédito não soma (Rafael 20/10).
    // Só exibição: nenhuma validação da tela ou da API usa este total.
    const totalJaAdiantado = totalCreditado(orcamento?.adiantamentosDoOrcamento);
    const valorOrc         = parseFloat(orcamento?.valorTotal || 0);
    const valorSolicitado  = parseFloat(virgulaPonto(valorSolicitadoManual)) || 0;
    const percentualOrcamento = percentualDoOrcamento(valorSolicitado, itens);

    // Moeda / câmbio
    const moedaOrc       = (orcamento?.moeda || 'real').toLowerCase();
    const cambioOrc      = parseFloat(orcamento?.cambio || 1) || 1;
    const isInternacional = moedaOrc !== 'real' && cambioOrc !== 1;
    const simboloOrig    = simboloMoeda(moedaOrc);
    const valorOrcBRL    = isInternacional ? valorOrc * cambioOrc : valorOrc;

    // Permissão — no modo renegociar vale a regra da equipe do evento (Rafael, 28/09)
    const perfil = localStorage.getItem('perfil');
    const podeEditar = podeRegistrarSolicitacaoAdiantamento(perfil, modoRenegociar);
    // Renegociar e Editar valor/vencimento (ambos avisam o Financeiro) = equipe do evento + admin/diretor
    const podeRenegociar = podeRenegociarAdiantamento(perfil);

    // Eventos (operador/responsavel) também agem nos adiantamentos do próprio evento (solicitar NF/excluir)
    const podeAgirAdiantamento = ['admin', 'diretor', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento', 'operador', 'responsavel'].includes(perfil);

    // Detecção do tipo de cliente
    // Usa campo `modelo` do participante (ex: "sanofi", "chiesi", "abbvie")
    // com fallback para nomefantasia — JSON retorna ev.cliente.modelo
    const ev            = orcamento?.evento || orcamento?.Evento || {};
    const clienteModelo = ((ev?.cliente?.modelo || ev?.Cliente?.modelo) || '').toLowerCase();
    const clienteLower  = (nomeCliente || '').toLowerCase();
    const isSanofi      = clienteModelo === 'sanofi'  || clienteLower.includes('sanofi');
    const isChiesi      = clienteModelo === 'chiesi'  || clienteLower.includes('chiesi');
    const isAbbvie      = clienteModelo === 'abbvie'  || clienteLower.includes('abbvie') || clienteLower.includes('abbv');
    const temCliente    = isSanofi || isChiesi || isAbbvie;
    // Quem exige anexo vem do servidor. Antes so a Abbvie tinha campo de upload,
    // entao Sanofi/Chiesi nao TINHAM como cumprir a exigencia de pedido de compra.
    const exigeAnexo    = !!(requisitos && requisitos.anexo && requisitos.anexo.obrigatorio);
    // O PEDIDO DE COMPRA e do EVENTO (tabela eventopo) — nao se anexa aqui.
    // Só a proposta da Abbvie e anexada na propria solicitacao.
    const anexoNoEvento = (requisitos && requisitos.anexo_fonte) === 'evento_po';
    const temAnexoOk    = !!(requisitos && requisitos.tem_anexo);
    const rotuloAnexo   = (requisitos && requisitos.anexo && requisitos.anexo.rotulo) || 'Proposta';
    const ajudaAnexo    = (requisitos && requisitos.anexo && requisitos.anexo.ajuda) || '';
    // Tooltip: texto GLOBAL (vale para todo cliente). Obrigatoriedade: por cliente.
    const ajudaDe       = (campo) => (requisitos && requisitos.ajuda && requisitos.ajuda[campo] && requisitos.ajuda[campo].ajuda) || '';
    const exigeCampo    = (campo) => !!(requisitos && requisitos.campos && requisitos.campos[campo] && requisitos.campos[campo].obrigatorio);
    // Pendencias do REGISTRO (nao da renegociacao, que segue com `requisitos.pode_enviar`).
    const pendenciasEnvio = modoRenegociar ? [] : [
        ...pendenciasSolicitacaoAdiantamento(requisitos, { codigoSap, loginRequisitante }),
        ...pendenciasComplemento(itens, tipoAdiantamento),
    ];

    // POs do evento formatadas
    const posEvento = eventoPos.length > 0
        ? eventoPos.map(p => p.numero || p.Numero || '').filter(Boolean).join(', ')
        : '';

    // "Não se aplica" é uma DECISÃO tomada no evento, não uma pendência — escrever
    // "(sem PO cadastrada)" nesse caso faz o operador procurar uma PO que ninguém
    // vai cadastrar (print do Rafael, 10/09).
    //
    // `evento.ponaoaplicavel` é varchar('sim'/'nao'), não boolean: um Boolean()
    // direto daria true também para 'nao', que é o caso da maioria dos eventos.
    // Mesma leitura que o FaturamentoController::dadosDaPo faz no back.
    const poNaoSeAplica = String(ev?.ponaoaplicavel || '').trim().toLowerCase() === 'sim';
    const avisoPo = avisoPoEvento(requisitos, { poNaoSeAplica });
    const textoPoEvento = posEvento
        ? posEvento
        : (poNaoSeAplica ? 'Não se aplica (marcado no evento)' : '(sem PO cadastrada)');

    // Proposta já enviada
    const propostaExistente = orcamento?.AdiantamentoDetalhes?.PropostaArquivo
        || orcamento?.adiantamento_detalhes?.proposta_arquivo
        || null;

    // Agrupamento por FORNECEDOR (antes era pela categoria do item). O adiantamento
    // é pedido para um fornecedor — sem o nome dele no cabeçalho, o operador não
    // sabia para quem estava pedindo (Rafael 2026-08-04). A categoria continua
    // visível na linha de cada subitem.
    const gruposMap = {};
    itens.forEach(item => {
        const chave = item.fornecedorNome || 'Sem fornecedor';
        if (!gruposMap[chave]) gruposMap[chave] = [];
        gruposMap[chave].push(item);
    });
    const gruposEntries = Object.entries(gruposMap)
        .sort((a, b) => a[0].localeCompare(b[0], 'pt-BR'));

    // ─── Loading state ───────────────────────────────────────────────────────
    if (carregando) {
        return (
            <ErpTemplate>
                <div className="main-content container-fluid d-flex align-items-center justify-content-center" style={{ height: '60vh' }}>
                    <div className="text-muted">Carregando orçamento...</div>
                </div>
            </ErpTemplate>
        );
    }

    if (!orcamento) return null;

    // ─── Render ─────────────────────────────────────────────────────────────
    return (
        <ErpTemplate>
            <div className="main-content container-fluid pb-5 fin-pp">

                {/* ── Banner renegociação ────────────────────────────────────── */}
                {modoRenegociar && (
                    <div className="d-flex align-items-center gap-2 mb-3 mt-2" style={{ background: 'var(--fin-wnb)', color: 'var(--fin-wn)', border: '1px solid var(--fin-wn)', borderLeft: '4px solid var(--fin-dg)', borderRadius: 'var(--fin-rds)', padding: '10px 14px', fontSize: '0.85rem' }}>
                        <span style={{ fontSize: '1.4rem' }}>🔄</span>
                        <div>
                            <strong>Modo renegociação</strong> — Este adiantamento foi marcado como <strong>Não Creditado</strong>.
                            Ajuste os fornecedores e o valor abaixo e clique em <strong>Renegociar e Notificar Financeiro</strong>.
                        </div>
                    </div>
                )}

                {/* ── Cabeçalho ─────────────────────────────────────────────── */}
                <div className="d-flex align-items-start justify-content-between mb-4 pt-2">
                    <div>
                        <h4 className="mb-0 fw-semibold">
                            {modoRenegociar ? 'Renegociar Adiantamento' : 'Solicitar Adiantamento'} — Orçamento #{orcamento.codigo}
                        </h4>
                        <div className="text-muted" style={{ fontSize: '0.9rem' }}>
                            {nomeEvento}{nomeCliente ? ` · ${nomeCliente}` : ''}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--sm"
                        onClick={voltarParaOrcamentos}
                    >
                        <FaArrowLeft size={12} className="me-1" /> Voltar para Orçamentos
                    </button>
                </div>

                {/* ── Navegação por abas ────────────────────────────────────── */}
                {(() => {
                    const adts = orcamento?.adiantamentosDoOrcamento || [];
                    const recs = orcamento ? obterRecibos(orcamento) : [];
                    const tabs = [
                        { id: 'registrar', label: '📋 Registrar Adiantamento' },
                        { id: 'lista',     label: `💰 Adiantamentos${adts.length > 0 ? ` (${adts.length})` : ''}` },
                        { id: 'recibos',   label: `🧾 Recibos${recs.length > 0 ? ` (${recs.length})` : ''}` },
                    ];
                    return (
                        <div className="fin-pp__tabs">
                            {tabs.map(t => (
                                <button
                                    key={t.id}
                                    type="button"
                                    onClick={() => setAbaAtiva(t.id)}
                                    className={`fin-pp__tab${abaAtiva === t.id ? ' is-active' : ''}`}
                                >
                                    {t.label}
                                </button>
                            ))}
                        </div>
                    );
                })()}

                {/* ── Aviso de câmbio ───────────────────────────────────────── */}
                {orcamento && resumirFechamentoExterior(orcamento).ativo && <><FechamentoExteriorResumo orcamento={orcamento} compacto /><div className="alert alert-info small">O valor de cada item abaixo é o valor cheio na etapa escolhida, com o câmbio dessa etapa e as taxas do pagamento no exterior (IOF/IR, envio e NF; no Fechamento concluído, as reais). O ledger não cria títulos nem altera a solicitação.</div></>}
                {temItemEmOutraMoeda(itens) && (
                    <div className="mb-3 d-flex align-items-center gap-2" data-adiantamento-banner-moeda style={{ background: 'var(--fin-wnb)', color: 'var(--fin-wn)', border: '1px solid var(--fin-wn)', borderRadius: 'var(--fin-rds)', padding: '10px 14px', fontSize: '0.85rem' }}>
                        <span>💱</span>
                        <span>
                            Cada item aparece na <strong>moeda dele no orçamento</strong> e convertido para R$ pelo <strong>câmbio da etapa</strong>,
                            com as taxas do pagamento no exterior (sem o FEE). A soma e o valor enviado ao Financeiro são <strong>em R$</strong>, pelo valor cheio.
                        </span>
                    </div>
                )}

                {/* ── Métricas ──────────────────────────────────────────────── */}
                <div className="row g-3 mb-4">
                    <div className="col-sm-4">
                        <div className="fin-pp__card h-100">
                            <div className="text-center py-3">
                                <div className="text-uppercase text-muted mb-1" style={{ fontSize: '0.68rem', letterSpacing: '0.05em' }}>Valor do Orçamento</div>
                                {isInternacional ? (
                                    <>
                                        <div className="fw-semibold fs-5">{simboloOrig} {valorOrc.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                                        <div className="text-muted" style={{ fontSize: '0.78rem' }}>≈ {moeda(valorOrcBRL)} · câmbio {cambioOrc.toFixed(4)}</div>
                                    </>
                                ) : (
                                    <div className="fw-semibold fs-5">{moeda(valorOrc)}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="fin-pp__card h-100">
                            <div className="text-center py-3">
                                <div className="text-uppercase text-muted mb-1" style={{ fontSize: '0.68rem', letterSpacing: '0.05em' }}>Já Adiantado</div>
                                <div className="fw-semibold fs-5 text-success">{moeda(totalJaAdiantado)}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="fin-pp__card h-100">
                            <div className="text-center py-3">
                                <div className="text-uppercase text-muted mb-1" style={{ fontSize: '0.68rem', letterSpacing: '0.05em' }}>Itens Disponíveis</div>
                                <div className="fw-semibold fs-5 text-primary">
                                    {itens.filter(i => !itemBloqueado(i, tipoAdiantamento)).length} itens
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Tab 1: Registrar ─────────────────────────────────────── */}
                {abaAtiva === 'registrar' && <div className="row g-4">

                    {/* ── Coluna esquerda — formulário ───────────────────────── */}
                    <div className="col-lg-8">

                        {/* Seção 1 — Tipo */}
                        <div className="fin-pp__card mb-4">
                            <div style={{ padding: 18 }}>
                                <div className="fw-semibold text-uppercase text-muted mb-3" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                    1 · Tipo de Solicitação
                                </div>
                                <div style={{ display: 'flex', gap: 8, alignItems: 'stretch' }}>
                                    {TIPOS_CONFIG.map(tipo => {
                                        const ativo = tipoAdiantamento === tipo.id;
                                        return (
                                            <button
                                                key={tipo.id}
                                                type="button"
                                                onClick={() => {
                                                    setTipoAdiantamento(tipo.id);
                                                    // Saindo do "Novo adiantamento": itens de complemento voltam a ser bloqueados.
                                                    if (itens.some(i => i.selecionado && itemBloqueado(i, tipo.id))) {
                                                        const novos = itens.map(i => (i.selecionado && itemBloqueado(i, tipo.id) ? { ...i, selecionado: false } : i));
                                                        setItens(novos);
                                                        const total = calcularTotal(novos);
                                                        setValorSolicitadoManual(valorPelaSelecao(total, false));
                                                        setPercentualDigitado(null);
                                                    }
                                                }}
                                                style={{
                                                    flex: '1 1 0',
                                                    minWidth: 0,
                                                    backgroundColor: ativo ? tipo.cor + '14' : '#fff',
                                                    border: (ativo ? '2px' : '1px') + ' solid ' + (ativo ? tipo.cor : '#dee2e6'),
                                                    borderRadius: '8px',
                                                    padding: '12px 16px',
                                                    transition: 'all 0.15s',
                                                    cursor: 'pointer',
                                                    textAlign: 'left',
                                                    whiteSpace: 'normal',
                                                    height: 'auto',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start',
                                                    gap: 4,
                                                }}
                                            >
                                                <div style={{ fontSize: '1.2rem', lineHeight: 1 }}>{tipo.icon}</div>
                                                <div style={{ fontSize: '0.85rem', fontWeight: 600, color: ativo ? tipo.cor : '#333', wordBreak: 'break-word' }}>{tipo.label}</div>
                                                <div style={{ fontSize: '0.75rem', color: '#586478', wordBreak: 'break-word' }}>{tipo.sub}</div>
                                            </button>
                                        );
                                    })}
                                </div>
                                {tipoAdiantamento === 'urgente' && (
                                    <div className="mt-3" style={{ background: 'var(--fin-dgb)', color: 'var(--fin-dg)', border: '1px solid var(--fin-dg)', borderRadius: 'var(--fin-rds)', padding: '10px 14px', fontSize: '0.85rem' }}>
                                        ⚠️ Pagamento urgente requer aprovação da diretoria. Informe a justificativa abaixo.
                                    </div>
                                )}
                                {tipoAdiantamento === 'novo' && (
                                    <div className="mt-3" style={{ background: 'var(--fin-wnb)', color: 'var(--fin-wn)', border: '1px solid var(--fin-wn)', borderRadius: 'var(--fin-rds)', padding: '10px 14px', fontSize: '0.85rem' }}>
                                        🔄 Novo adiantamento após verba anterior esgotada. Comprovantes obrigatórios.
                                        <div className="mt-1">Complemento: os itens que já têm adiantamento ficam liberados — selecione-os e digite o valor do complemento.</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Seção 2 — Valor */}
                        <div className="fin-pp__card mb-4">
                            <div style={{ padding: 18 }}>
                                <div className="fw-semibold text-uppercase text-muted mb-3" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                    2 · Valor da Solicitação
                                </div>
                                <div className="row g-3 align-items-end">
                                    <div className="col-sm-4">
                                        <FinField label="Valor (R$)">
                                            <FinValor allowNegative={false}
                                                fixedDecimalScale
                                                moeda="real"
                                                value={valorSolicitadoManual}
                                                onValueChange={({ value }) => setValorSolicitadoManual(value)}
                                                placeholder="R$ 0,00"
                                            />
                                        </FinField>
                                    </div>
                                    <div className="col-sm-3">
                                        {/* Percentual (Inter 14/10): % da soma dos itens selecionados → preenche o Valor. O envio segue em R$. */}
                                        <FinField label="% dos itens selecionados">
                                            <FinPercentual
                                                id="percentualAdiantamento"
                                                decimalScale={2}
                                                placeholder="0%"
                                                disabled={totalSelecionado <= 0}
                                                title={totalSelecionado <= 0 ? 'Selecione os itens para pedir um percentual deles.' : 'Percentual da soma dos itens selecionados; o valor em R$ é calculado.'}
                                                value={percentualDigitado !== null ? percentualDigitado
                                                    : (totalSelecionado > 0 && valorSolicitado > 0 ? Math.round((valorSolicitado / totalSelecionado) * 10000) / 100 : '')}
                                                onValueChange={({ value, floatValue }, { source }) => {
                                                    if (source !== 'event') return;
                                                    setPercentualDigitado(value);
                                                    if (floatValue === undefined || totalSelecionado <= 0) return;
                                                    setValorSolicitadoManual((Math.round(totalSelecionado * floatValue) / 100).toFixed(2));
                                                }}
                                                onBlur={() => setPercentualDigitado(null)}
                                            />
                                        </FinField>
                                    </div>
                                    <div className="col-sm-5">
                                        <div className="text-muted small">
                                            {itens.filter(i => i.selecionado).length} de{' '}
                                            {itens.filter(i => !itemBloqueado(i, tipoAdiantamento)).length} itens selecionados
                                        </div>
                                        {/* D-0146: base = valor cheio de todos os itens que podem ir para o adiantamento, na
                                            etapa escolhida (antes valorTotal × câmbio, sem as taxas do exterior: 115%). */}
                                        {percentualOrcamento !== null && (
                                            <div className="text-muted small">
                                                {percentualOrcamento.toFixed(1).replace('.', ',')}% do valor do orçamento
                                            </div>
                                        )}
                                        <div className="text-muted small">
                                            Soma dos itens: {moeda(totalSelecionado)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Seção 3 — Itens */}
                        <div className="fin-pp__card mb-4">
                            <div style={{ padding: 18 }}>
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div className="fw-semibold text-uppercase text-muted" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                        3 · Itens do Orçamento
                                    </div>
                                    <div className="d-flex gap-1">
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => marcarTodos(true)}>Marcar todos</button>
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => marcarTodos(false)}>Limpar</button>
                                    </div>
                                </div>

                                {/* D-0126: etapa do valor — a do fornecedor (padrão) ou uma só para todos os itens. */}
                                <div className="mb-3" data-adiantamento-etapa>
                                    <div className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>Valor pela etapa</div>
                                    <div className="fin-pp__seg">
                                        {ESCOLHAS_ETAPA.map((e) => (
                                            <button key={e.valor} type="button"
                                                onClick={() => trocarEtapaValor(e.valor)}
                                                className={'fin-pp__seg-btn' + (etapaValor === e.valor ? ' is-active' : '')}>
                                                {e.rotulo}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {itens.length === 0 ? (
                                    <div className="text-center text-muted py-5">
                                        {etapaValor === ETAPA_VIGENTE
                                            ? 'Nenhum item com valor na etapa vigente (Pré-evento, Negociado ou Fechamento) neste orçamento.'
                                            : 'Nenhum item com valor nesta etapa. Escolha outra etapa acima.'}
                                    </div>
                                ) : (
                                    gruposEntries.map(([nomeGrupo, itensGrupo], gIdx) => {
                                        const expanded  = expandedGrupos[gIdx] !== false;
                                        const disponiveis = itensGrupo.filter(i => !i.temAdiantamento); // "marcar grupo" só pega itens livres
                                        const selecionadosGrupo = disponiveis.filter(i => i.selecionado);
                                        const todosSel  = disponiveis.length > 0 && selecionadosGrupo.length === disponiveis.length;
                                        const indet     = selecionadosGrupo.length > 0 && !todosSel;
                                        const contador  = contadorGrupo(itensGrupo, tipoAdiantamento);

                                        return (
                                            <div key={gIdx} className="border rounded mb-2 overflow-hidden">
                                                {/* Cabeçalho do grupo */}
                                                <div
                                                    className="d-flex align-items-center gap-2 px-3 py-2"
                                                    style={{ backgroundColor: '#f8f9fa', cursor: 'pointer', userSelect: 'none' }}
                                                    onClick={() => toggleExpandGrupo(gIdx)}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input mt-0"
                                                        checked={todosSel}
                                                        ref={el => { if (el) el.indeterminate = indet; }}
                                                        onChange={(e) => { e.stopPropagation(); toggleGrupo(itensGrupo, e.target.checked); }}
                                                        onClick={e => e.stopPropagation()}
                                                    />
                                                    <span className="fw-semibold small flex-grow-1">
                                                        🏛 {nomeGrupo}
                                                        {temItemEmOutraMoeda(itensGrupo) && (
                                                            <span className="badge ms-2" style={{ background: '#e8f0fe', color: '#1a56db', fontSize: '0.65rem', fontWeight: 600 }}>
                                                                {[...new Set(itensGrupo.filter(i => i.moedaItem !== 'real').map(i => i.simboloItem))].join(' · ')} → R$
                                                            </span>
                                                        )}
                                                    </span>
                                                    <span className="badge bg-light text-dark border small me-1">
                                                        {contador.selecionados}/{contador.total}
                                                    </span>
                                                    <span className="text-muted" style={{ fontSize: '0.7rem' }}>{expanded ? '▲' : '▼'}</span>
                                                </div>

                                                {/* Subitens */}
                                                {expanded && itensGrupo.map(item => (
                                                    <div
                                                        key={item.id}
                                                        className="d-flex align-items-center gap-2 px-3 py-2 border-top"
                                                        style={{
                                                            backgroundColor: item.selecionado ? '#e7f3ff' : item.temAdiantamento ? '#fff8e1' : '#fff',
                                                            cursor: itemBloqueado(item, tipoAdiantamento) ? 'not-allowed' : 'pointer',
                                                            opacity: itemBloqueado(item, tipoAdiantamento) ? 0.75 : 1,
                                                        }}
                                                        onClick={() => !itemBloqueado(item, tipoAdiantamento) && toggleItem(item.id)}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input mt-0"
                                                            checked={item.selecionado}
                                                            disabled={itemBloqueado(item, tipoAdiantamento)}
                                                            onChange={() => !itemBloqueado(item, tipoAdiantamento) && toggleItem(item.id)}
                                                            onClick={e => e.stopPropagation()}
                                                        />
                                                        <span className="small flex-grow-1 d-flex align-items-center flex-wrap gap-1">
                                                            <span>{item.nomeSubitem}</span>
                                                            <span className="text-muted" style={{ fontSize: '0.72rem' }}>· {item.nomeItem}</span>
                                                            {item.adiantamentoInfo && (() => {
                                                                // "Creditado" só com o crédito informado pelo Financeiro; só recibo = "Recibo recebido" (Rafael 20/10).
                                                                const selo = seloItemAdiantamento(item.adiantamentoInfo);
                                                                return (
                                                                    <span className="badge ms-2" style={{ fontSize: '0.7em', background: selo.fundo, color: selo.cor }}>
                                                                        {selo.texto}
                                                                        {itemLiberadoParaComplemento(item, tipoAdiantamento) && ' · 🔁 complemento liberado'}
                                                                    </span>
                                                                );
                                                            })()}
                                                        </span>
                                                        {textoValorNaMoeda({ moeda: item.moedaItem, simbolo: item.simboloItem, valorOrigem: item.valorOriginal, cambio: item.cambioItem, encargosBrl: item.encargosItem }) ? (
                                                            <span className="text-end" style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }} data-adiantamento-item-moeda={item.moedaItem}>
                                                                <span className="text-muted">{textoValorNaMoeda({ moeda: item.moedaItem, simbolo: item.simboloItem, valorOrigem: item.valorOriginal, cambio: item.cambioItem, encargosBrl: item.encargosItem })}</span>
                                                                <span className="text-muted mx-1">→</span>
                                                                <span className="fw-semibold text-primary">{moeda(item.valorPreEvento)}</span>
                                                                {textoTaxasItem(item.encargosItem) && (
                                                                    <span className="d-block mt-1" data-adiantamento-item-taxas>
                                                                        <span className="fin-pp__pill fin-pp__pill--plain is-info" title="IOF/IR, envio e NF do pagamento no exterior">{textoTaxasItem(item.encargosItem)}</span>
                                                                    </span>
                                                                )}
                                                                {item.etapaItem && <span className="d-block text-muted" style={{ fontSize: '0.7rem' }}>{item.moedaItem === 'real' ? item.etapaItem : `câmbio do ${item.etapaItem}`}</span>}
                                                            </span>
                                                        ) : (
                                                            <span className="text-muted small fw-semibold">{moeda(item.valorPreEvento)}</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>

                        {/* Seção 4 — Detalhes */}
                        <div className="fin-pp__card mb-4">
                            <div style={{ padding: 18 }}>
                                <div className="fw-semibold text-uppercase text-muted mb-3" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                    4 · Detalhes
                                </div>
                                <div className="row g-3">
                                    <div className="col-sm-5">
                                        <FinField label="Data de pagamento (previsão)">
                                            <input
                                                type="date"
                                                className="fin-pp__input"
                                                style={{ paddingLeft: 14 }}
                                                value={dataAdiantamento}
                                                onChange={e => setDataAdiantamento(e.target.value)}
                                            />
                                        </FinField>
                                    </div>
                                    {!modoRenegociar && podeMarcarClienteJaPagou(perfil) && (
                                        <div className="col-12">
                                            <FinCheck label="Adiantamento já feito (o cliente já pagou)"
                                                checked={clienteJaPagou} onChange={e => setClienteJaPagou(e.target.checked)} />
                                            <div className="fin-pp__cell-muted" style={{ fontSize: '0.75rem', marginTop: 4 }}>
                                                Só avisa o Financeiro para anexar o recibo e dar a baixa. O procedimento não muda.
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-12">
                                        <FinField label="Justificativa" full>
                                            <FinTextarea
                                                rows={3}
                                                value={justificativa}
                                                onChange={e => setJustificativa(e.target.value)}
                                                placeholder={
                                                    tipoAdiantamento === 'urgente'
                                                        ? 'Explique a urgência e o impacto caso não seja pago antes da janela regular...'
                                                        : tipoAdiantamento === 'novo'
                                                            ? 'Descreva como a verba anterior foi utilizada e por que é necessário novo adiantamento...'
                                                            : 'Observações sobre esta solicitação de adiantamento...'
                                                }
                                            />
                                        </FinField>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Seção 5 — Dados específicos do cliente */}
                        {temCliente && (
                            <div className="fin-pp__card mb-4" style={{ borderLeft: '3px solid #6f42c1' }}>
                                <div style={{ padding: 18 }}>
                                    <div className="fw-semibold text-uppercase text-muted mb-3" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                        5 · Dados do Cliente — <span style={{ color: '#6f42c1' }}>{nomeCliente}</span>
                                    </div>

                                    {/* ── Campos comuns a todos os clientes ── */}
                                    <div className="row g-3 mb-3">
                                        {/* Requisitante interno */}
                                        <div className="col-12">
                                            <FinField label="Requisitante Eventos (interno Access)" ajuda={ajudaDe('requisitante')} full>
                                                <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                    {eventoResponsavel || '(não informado no evento)'}
                                                </div>
                                            </FinField>
                                        </div>

                                        {/* PO do evento */}
                                        <div className="col-12">
                                            <FinField label="P.O. do Evento" full>
                                                <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                    {textoPoEvento}
                                                </div>
                                            </FinField>
                                        </div>
                                    </div>

                                    {/* ── Campos exclusivos Sanofi ── */}
                                    {isSanofi && (
                                        <div className="row g-3">
                                            <div className="col-sm-6">
                                                <FinField label="Login do Requisitante Sanofi" required={exigeCampo('login_requisitante')} ajuda={ajudaDe('login_requisitante')} full>
                                                    <FinInput
                                                        type="email"
                                                        value={loginRequisitante}
                                                        onChange={e => setLoginRequisitante(e.target.value)}
                                                        placeholder="email@sanofi.com"
                                                    />
                                                </FinField>
                                            </div>
                                            <div className="col-sm-6">
                                                <FinField label="Código SAP" required={exigeCampo('codigo_sap')} ajuda={ajudaDe('codigo_sap')} full>
                                                    <FinInput
                                                        type="text"
                                                        value={codigoSap}
                                                        onChange={e => setCodigoSap(e.target.value)}
                                                        placeholder="Ex: 4500012345"
                                                    />
                                                </FinField>
                                            </div>
                                            {/* "E-mail que recebe o recibo" saiu (Rafael 20/10): o recibo vai aos responsáveis do evento. */}
                                            <div className="col-sm-6">
                                                <FinField label="Nome do Evento e Período" full>
                                                    <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                        {[nomeEvento, eventoData ? `${eventoData}${eventoDataFim ? ' a ' + eventoDataFim : ''}` : ''].filter(Boolean).join(' | ')}
                                                    </div>
                                                </FinField>
                                            </div>
                                            <div className="col-sm-6">
                                                <FinField label="WBS (Número OI)" ajuda={ajudaDe('wbs')} full>
                                                    <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                        {eventoNumeroOi || '(não informado)'}
                                                    </div>
                                                </FinField>
                                            </div>
                                            <div className="col-sm-6">
                                                {/* Centro de custo do evento (Inter 14/10): a Sanofi pede no adiantamento. Edita-se no evento. */}
                                                <FinField label="Centro de Custo" full>
                                                    <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                        {eventoCentroCusto || '(não informado — preencha no evento, aba Faturamento)'}
                                                    </div>
                                                </FinField>
                                            </div>
                                            <div className="col-sm-6">
                                                <FinField label="1-CRM / Identificação" ajuda={ajudaDe('crm')} full>
                                                    <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                        {eventoIdentificacao || '(não informado)'}
                                                    </div>
                                                </FinField>
                                            </div>
                                            <div className="col-sm-6">
                                                <FinField label="Link do Evento" ajuda={ajudaDe('link_evento')} full>
                                                    {eventoLink ? (
                                                        <a href={eventoLink} target="_blank" rel="noreferrer" className="fin-pp__input text-truncate" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                            {eventoLink}
                                                        </a>
                                                    ) : (
                                                        <div className="fin-pp__input" style={{ paddingLeft: 14, display: 'flex', alignItems: 'center', background: 'var(--fin-sf2)' }}>
                                                            (não informado)
                                                        </div>
                                                    )}
                                                </FinField>
                                            </div>
                                        </div>
                                    )}

                                    {/* ── PO do EVENTO: so informa o estado, nao anexa aqui ── */}
                                    {/* Rafael 16/10: a PO só avisa (não trava) até ele definir quais clientes exigem. */}
                                    {anexoNoEvento && avisoPo && (
                                        <div className="row g-3 mt-1">
                                            <div className="col-12">
                                                <FinField label={rotuloAnexo} ajuda={ajudaAnexo} full>
                                                    {avisoPo.tipo === 'ok' ? (
                                                        <div className="fin-pp__pill is-ok">
                                                            <FaCheck size={10} style={{ marginRight: 4 }} />
                                                            PO do evento anexado{posEvento ? ' — ' + posEvento : ''}
                                                        </div>
                                                    ) : avisoPo.tipo === 'aviso' ? (
                                                        <div className="fin-pp__pill is-warn" style={{ whiteSpace: 'normal', textAlign: 'left' }}>
                                                            {avisoPo.texto}
                                                        </div>
                                                    ) : poNaoSeAplica ? (
                                                        // O campo acima já diz "Não se aplica (marcado no evento)".
                                                        // A marcação NÃO dispensa o documento para cliente que exige — a
                                                        // exigência vem do servidor (`requisitos.anexo.obrigatorio`).
                                                        <div className="fin-pp__pill is-warn" style={{ whiteSpace: 'normal', textAlign: 'left' }}>
                                                            Este evento está marcado como <strong>P.O. não se aplica</strong>,
                                                            mas este cliente exige o documento para o adiantamento.
                                                            Anexe a P.O. na aba P.O. do evento antes de solicitar.
                                                        </div>
                                                    ) : (
                                                        <div className="fin-pp__pill is-warn" style={{ whiteSpace: 'normal', textAlign: 'left' }}>
                                                            Este evento ainda não tem PO com arquivo anexado.
                                                            Cadastre na aba P.O. do evento antes de solicitar o adiantamento.
                                                        </div>
                                                    )}
                                                </FinField>
                                            </div>
                                        </div>
                                    )}

                                    {/* ── Anexo na propria solicitacao (proposta Abbvie) ── */}
                                    {((!anexoNoEvento && exigeAnexo) || isAbbvie) && (
                                        <div className="row g-3 mt-1">
                                            <div className="col-12">
                                                <FinField label={rotuloAnexo + (exigeAnexo ? ' *' : '')} full>
                                                    {ajudaAnexo && (
                                                        <small className="text-muted d-block mb-2">{ajudaAnexo}</small>
                                                    )}
                                                    {propostaExistente && (
                                                        <div className="mb-2">
                                                            <a
                                                                href={propostaExistente.link || '#'}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="fin-pp__btn fin-pp__btn--ok fin-pp__btn--sm me-2"
                                                            >
                                                                <FaDownload size={12} className="me-1" /> Proposta atual
                                                            </a>
                                                            <small className="text-muted">{propostaExistente.nome}</small>
                                                        </div>
                                                    )}
                                                    <div className="d-flex gap-2 align-items-center">
                                                        <input
                                                            ref={propostaRef}
                                                            type="file"
                                                            className="fin-pp__input"
                                                            accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                            onChange={e => setPropostaArquivo(e.target.files[0])}
                                                            style={{ paddingLeft: 14, display: 'flex', alignItems: 'center' }}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="fin-pp__btn fin-pp__btn--sm text-nowrap"
                                                            onClick={uploadProposta}
                                                            disabled={!propostaArquivo || propostaEnviando}
                                                        >
                                                            {propostaEnviando ? 'Enviando...' : <><FaUpload size={12} className="me-1" /> Enviar</>}
                                                        </button>
                                                    </div>
                                                    <small className="text-muted">PDF, DOC, XLS</small>
                                                </FinField>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Seção 6 — Comprovantes (apenas para tipo 'novo') */}
                        {tipoAdiantamento === 'novo' && (
                            <div className="fin-pp__card mb-4" style={{ borderLeft: '3px solid #ffc107' }}>
                                <div style={{ padding: 18 }}>
                                    <div className="fw-semibold text-uppercase text-muted mb-3" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                        6 · Comprovante do adiantamento anterior <span className="text-danger">(obrigatório)</span>
                                    </div>
                                    <div className="row g-3">
                                        <div className="col-sm-6">
                                            <FinField label="Valor (R$)" full>
                                                <FinValor allowNegative={false}
                                                    fixedDecimalScale={false}
                                                    moeda="real"
                                                    value={valorRecibo}
                                                    onValueChange={({ value }) => setValorRecibo(value)}
                                                    placeholder="R$ 0,00"
                                                />
                                            </FinField>
                                        </div>
                                        <div className="col-sm-6">
                                            <FinField label="Data de previsão de pagamento" full>
                                                <input
                                                    type="date"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    value={dataPrevisaoPagamento}
                                                    onChange={e => setDataPrevisaoPagamento(e.target.value)}
                                                />
                                            </FinField>
                                        </div>
                                        <div className="col-12">
                                            <FinField label="Observações" full>
                                                <FinTextarea
                                                    rows={2}
                                                    value={observacaoRecibo}
                                                    onChange={e => setObservacaoRecibo(e.target.value)}
                                                    placeholder="Observações sobre o comprovante..."
                                                />
                                            </FinField>
                                        </div>
                                        <div className="col-sm-4">
                                            <FinField label="Login SAP" full>
                                                <FinInput
                                                    type="text"
                                                    value={loginSapRecibo}
                                                    onChange={e => setLoginSapRecibo(e.target.value)}
                                                />
                                            </FinField>
                                        </div>
                                        <div className="col-sm-8">
                                            <FinField label="Arquivo" full>
                                                <input
                                                    type="file"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14, display: 'flex', alignItems: 'center' }}
                                                    accept={ACEITE_RECIBO}
                                                    onChange={e => setArquivoRecibo(e.target.files[0])}
                                                />
                                                <small className="text-muted">Somente PDF</small>
                                            </FinField>
                                        </div>
                                        <div className="col-12 text-end">
                                            <button
                                                type="button"
                                                className="fin-pp__btn"
                                                onClick={uploadRecibo}
                                                disabled={!arquivoRecibo || !valorRecibo || enviandoRecibo}
                                            >
                                                <FaUpload size={14} className="me-1" /> Enviar Comprovante
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* ── Sidebar direita ────────────────────────────────────── */}
                    <div className="col-lg-4">

                        {/* Card resumo + botão principal */}
                        <div className="fin-pp__card mb-4">
                            <div style={{ padding: 18 }}>
                                <div className="fw-semibold text-uppercase text-muted mb-3" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
                                    Resumo
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted small">Itens selecionados</span>
                                    <span className="small fw-semibold">{itens.filter(i => i.selecionado).length}</span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted small">Soma dos itens</span>
                                    <span className="small">{moeda(totalSelecionado)}</span>
                                </div>
                                {/* D-0126: as taxas do exterior já estão na soma; a linha só mostra quanto delas entrou. */}
                                {totalTaxas(itens.filter(i => i.selecionado)) > 0 && (
                                    <div className="d-flex justify-content-between mb-2" data-adiantamento-taxas-resumo>
                                        <span className="text-muted small">Taxas incluídas (IOF/IR, envio, NF)</span>
                                        <span className="small">{moeda(totalTaxas(itens.filter(i => i.selecionado)))}</span>
                                    </div>
                                )}
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted small">Já adiantado</span>
                                    <span className="small text-success">{moeda(totalJaAdiantado)}</span>
                                </div>
                                <hr className="my-2" />
                                <div className="d-flex justify-content-between mb-1 align-items-center">
                                    <span className="fw-semibold">Valor da solicitação</span>
                                    <span className="fw-semibold text-primary" style={{ fontSize: '1.15rem' }}>{moeda(valorSolicitado)}</span>
                                </div>
                                {textoQuebraPorMoeda(itens.filter(i => i.selecionado)) && (
                                    <div className="text-end text-muted mb-2" style={{ fontSize: '0.75rem' }} data-adiantamento-quebra-moeda>
                                        Itens: {textoQuebraPorMoeda(itens.filter(i => i.selecionado))}
                                    </div>
                                )}

                                {podeEditar && pendenciasEnvio.length > 0 && (
                                    <div data-qa="pendencias-adiantamento" className="fin-pp__pill is-warn mb-2" style={{ display: 'block', whiteSpace: 'normal', textAlign: 'left' }}>
                                        {pendenciasEnvio.map(msg => <div key={msg}>{msg}</div>)}
                                    </div>
                                )}
                                {podeEditar ? (
                                    <button
                                        type="button"
                                        className={`fin-pp__btn fin-pp__btn--tall w-100 mb-2${modoRenegociar ? '' : ' fin-pp__btn--primary'}`}
                                        onClick={modoRenegociar ? renegociarSolicitacao : registrarSolicitacao}
                                        disabled={enviandoSolicitacao || valorSolicitado <= 0 || itens.filter(i => i.selecionado).length === 0 || pendenciasEnvio.length > 0}
                                    >
                                        <FaMoneyBillWave size={14} className="me-1" />
                                        {enviandoSolicitacao ? 'Enviando...' : (modoRenegociar ? '🔄 Renegociar e Notificar Financeiro' : 'Registrar Solicitação')}
                                    </button>
                                ) : (
                                    <div className="mb-2" style={{ background: 'var(--fin-acw)', color: 'var(--fin-ac)', border: '1px solid var(--fin-ac)', borderRadius: 'var(--fin-rds)', padding: '10px 14px', fontSize: '0.85rem' }}>
                                        {modoRenegociar
                                            ? MENSAGEM_SEM_PERMISSAO_RENEGOCIAR
                                            : 'Somente o financeiro pode registrar solicitações.'}
                                    </div>
                                )}
                                <button
                                    type="button"
                                    className="fin-pp__btn w-100"
                                    onClick={voltarParaOrcamentos}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>

                    </div>
                </div>}

                {/* ── Tab 2: Lista de Adiantamentos ─────────────────────────── */}
                {abaAtiva === 'lista' && (() => {
                    const adts = orcamento?.adiantamentosDoOrcamento || [];

                    // Monta mapa subitemId -> { nomeItem, nomeSubitem, fornecedorNome, valorPreEvento }
                    const subitemMap = {};
                    const valoresSubitemLista = valoresAdiantamentoPorSubitem(orcamento || {});
                    (orcamento?.orcamentoitem || []).forEach(function(item) {
                        var nomeItem = (item.produto && item.produto.nome) ? item.produto.nome : 'Item';
                        (item.subitem || []).forEach(function(sub) {
                            var forn = sub.fornecedor;
                            var fornNome = forn
                                ? (forn.nomefantasia || forn.nome || ('Fornecedor #' + forn.id))
                                : null;
                            // limpa o padrão "codigo - nome - nomefantasia" que vem do backend
                            if (fornNome && fornNome.includes(' - ')) {
                                var partes = fornNome.split(' - ').map(function(p) { return p.trim(); }).filter(Boolean);
                                // pega o último não-vazio (nomefantasia ou nome)
                                fornNome = partes[partes.length - 1] || fornNome;
                            }
                            // D-0117: valor na moeda real do item e em R$ pelo câmbio da etapa vigente do fornecedor.
                            var valorInfo = valoresSubitemLista[String(sub.id)] || { valorOrigem: 0, valorBrl: 0 };
                            subitemMap[String(sub.id)] = {
                                nomeItem: nomeItem,
                                nomeSubitem: (sub.produto && sub.produto.nome) ? sub.produto.nome : 'Subitem',
                                fornecedorNome: fornNome,
                                valorOriginal:  valorInfo.valorOrigem,
                                valorPreEvento: valorInfo.valorBrl,
                            };
                        });
                    });
                    if (adts.length === 0) {
                        return (
                            <div className="fin-pp__card">
                                <div className="text-center text-muted py-5">
                                    Nenhum adiantamento solicitado ainda. Use a aba <strong>Registrar Adiantamento</strong>.
                                </div>
                            </div>
                        );
                    }
                    // ── Agrupamento por FORNECEDOR (padrão do PainelAdiantamentos do Financeiro,
                    //    que agrupa por evento; aqui já estamos no evento → agrupa por fornecedor) ──
                    const porFornecedor = adts.reduce(function(acc, adt) {
                        var nomes = [];
                        (adt.item_ids || []).forEach(function(sid) {
                            var info = subitemMap[String(sid)];
                            if (info && info.fornecedorNome && nomes.indexOf(info.fornecedorNome) === -1) {
                                nomes.push(info.fornecedorNome);
                            }
                        });
                        var chave = nomes.length === 0 ? 'Sem fornecedor'
                            : nomes.length === 1 ? nomes[0]
                            : 'Vários fornecedores';
                        if (!acc[chave]) acc[chave] = { nome: chave, adts: [] };
                        acc[chave].adts.push(adt);
                        return acc;
                    }, {});
                    const gruposForn = Object.values(porFornecedor);

                    return (
                        <div className="fin-pp__groups">
                            {gruposForn.map(function(grupo) {
                                const totalGrupo = grupo.adts.reduce(function(s, a) { return s + parseFloat(a.valor || 0); }, 0);
                                const emAberto = grupo.adts.filter(function(a) {
                                    return !a.excluido && !a.aprovado_diretor
                                        && a.status_pagamento !== 'creditado'
                                        && !(a.situacao === '2' || a.situacao === 2);
                                }).length;
                                const estaAberto = fornecedoresAbertos[grupo.nome] !== false;
                                const adtComRecibo = grupo.adts.find(function(a) { return !!a.arquivo_recibo_id; });

                                return (
                                    <div key={grupo.nome} className="fin-pp__grp">
                                        {/* ── Cabeçalho acordeão ── */}
                                        <div
                                            className="fin-pp__grp-head"
                                            onClick={() => setFornecedoresAbertos(prev => ({ ...prev, [grupo.nome]: !estaAberto }))}
                                        >
                                            <span className="fin-pp__grp-caret">
                                                {estaAberto ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}
                                            </span>
                                            <span className="fin-pp__grp-ic"><FaUserTie size={15} /></span>
                                            <div style={{ minWidth: 0, flex: 1 }}>
                                                <div className="fin-pp__grp-name">
                                                    {grupo.nome}
                                                    <span style={{ fontWeight: 400, fontSize: '0.8rem', color: 'var(--fin-mt)', marginLeft: 6 }}>
                                                        · {grupo.adts.length} parcela{grupo.adts.length !== 1 ? 's' : ''}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2, flexWrap: 'wrap' }}>
                                                    {emAberto > 0 && (
                                                        <span className="fin-pp__pill is-warn" style={{ fontSize: '0.72rem' }}>{emAberto} em aberto</span>
                                                    )}
                                                    {adtComRecibo && (
                                                        <button
                                                            type="button"
                                                            className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--ok"
                                                            style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                                            title="Baixar recibo de adiantamento"
                                                            onClick={function(e) {
                                                                e.stopPropagation();
                                                                window.open(process.env.REACT_APP_API_URL + '/arquivo/download/' + adtComRecibo.arquivo_recibo_id, '_blank');
                                                            }}
                                                        >
                                                            Recibo
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                            <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                                <div className="fin-pp__minicard-label">Total</div>
                                                <div className="fin-pp__minicard-value is-info">R$ {moeda(totalGrupo)}</div>
                                            </div>
                                        </div>

                                        {/* ── Tabela ── */}
                                        {estaAberto && (
                                            <div style={{ borderTop: '1px solid var(--fin-bd)' }}>
                                                <div className="fin-pp__tblwrap">
                                                    <table className="fin-pp__tbl" style={{ minWidth: 820, tableLayout: 'auto' }}>
                                                        <thead>
                                                            <tr>
                                                                <th>Situação</th>
                                                                <th>Status</th>
                                                                <th>Descrição</th>
                                                                <th>Vencimento</th>
                                                                <th style={{ textAlign: 'right' }}>Valor</th>
                                                                <th>Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {grupo.adts.map(function(adt) {
                                                                const isExcluido  = !!adt.excluido;
                                                                const isNaoCred   = adt.status_pagamento === 'nao_creditado';
                                                                const isPago      = adt.situacao === '2' || adt.situacao === 2;
                                                                // "Creditado" só quando o Financeiro informa o crédito (status_pagamento). Recibo anexado
                                                                // também seta aprovado_diretor (= liberado p/ Contas Pendentes) — isso não é crédito (Rafael 20/10).
                                                                const situacao    = situacaoAdiantamento(adt);
                                                                const isCreditado = situacao === 'creditado';
                                                                const isLiberado  = isCreditado || !!adt.aprovado_diretor;
                                                                const editando    = editandoParcelaId === adt.parcela_id;

                                                                // Fornecedores do adiantamento (detalhe por linha nos grupos agregados)
                                                                var fornsLinha = [];
                                                                (adt.item_ids || []).forEach(function(sid) {
                                                                    var info = subitemMap[String(sid)];
                                                                    if (info && info.fornecedorNome && fornsLinha.indexOf(info.fornecedorNome) === -1) {
                                                                        fornsLinha.push(info.fornecedorNome);
                                                                    }
                                                                });

                                                                const rows = [
                                                                    <tr key={adt.titulo_id} style={isExcluido ? { opacity: 0.6 } : undefined}>
                                                                        <td>
                                                                            {isExcluido ? (
                                                                                <span className="fin-pp__pill is-muted" title={adt.motivo_exclusao ? 'Motivo: ' + adt.motivo_exclusao : undefined}>Excluído</span>
                                                                            ) : isNaoCred ? (
                                                                                <span className="fin-pp__pill is-danger" title={adt.status_pagamento_obs ? 'Obs: ' + adt.status_pagamento_obs : 'Valor não caiu — renegociar com o fornecedor'}>Não creditado</span>
                                                                            ) : isCreditado ? (
                                                                                <span className="fin-pp__pill is-ok">Creditado</span>
                                                                            ) : situacao === 'recibo' ? (
                                                                                <span className="fin-pp__pill is-info" title="O Financeiro anexou o recibo. Vira Creditado quando o Financeiro informar que o valor caiu.">Recibo recebido</span>
                                                                            ) : (
                                                                                <span className="fin-pp__pill is-warn">Aberto</span>
                                                                            )}
                                                                            {adt.voltas > 0 && (
                                                                                <span className="fin-pp__minitag is-warn" style={{ marginLeft: 6 }} title={'Voltou do Financeiro ' + adt.voltas + (adt.voltas > 1 ? ' vezes' : ' vez') + ' (reprovado ou não creditado)'}>
                                                                                    ↩ Voltou {adt.voltas}x
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <span className="fin-pp__cell-muted" style={{ fontSize: '0.8rem' }} title={isNaoCred && adt.status_pagamento_obs ? 'Obs: ' + adt.status_pagamento_obs : undefined}>
                                                                                {isExcluido
                                                                                    ? (adt.data_exclusao ? 'Excluído em ' + fmtDatetime(adt.data_exclusao) : '—')
                                                                                    : isPago ? 'Pago'
                                                                                    : isNaoCred ? 'Renegociação pendente'
                                                                                    : isLiberado ? 'Aguardando Aprovação Pagamento'
                                                                                    : 'Aguardando aprovação'}
                                                                            </span>
                                                                        </td>
                                                                        <td className="fin-pp__cell-muted">
                                                                            {adt.descricao || 'Adiantamento'}
                                                                            <div style={{ fontSize: '0.72rem', color: 'var(--fin-mt)' }}>
                                                                                Solicitado em: {adt.created_at ? fmtDatetime(adt.created_at) : '—'}
                                                                                {(grupo.nome === 'Vários fornecedores' && fornsLinha.length > 0) && (
                                                                                    <> · {fornsLinha.join(', ')}</>
                                                                                )}
                                                                            </div>
                                                                            {!isExcluido && isCreditado && (adt.data_credito || adt.creditado_por_nome) && (
                                                                                <div style={{ fontSize: '0.72rem', color: '#0f5132' }}>
                                                                                    ✅ Valor creditado{adt.data_credito ? ' em ' + fmtDatetime(adt.data_credito) : ''}{adt.creditado_por_nome ? ' por ' + adt.creditado_por_nome : ''}
                                                                                </div>
                                                                            )}
                                                                            {adt.arquivo_recibo_id && (
                                                                                <div style={{ fontSize: '0.72rem', color: '#0f5132' }} title="O Financeiro já anexou o recibo deste adiantamento.">
                                                                                    📄 Recibo recebido
                                                                                </div>
                                                                            )}
                                                                            {adt.nf_recebida && (
                                                                                <div style={{ fontSize: '0.72rem', color: '#0f5132' }}>
                                                                                    {adt.arquivo_nf_id ? (
                                                                                        <a href="#nf" title="Baixar a nota fiscal"
                                                                                            style={{ color: '#0f5132', textDecoration: 'underline' }}
                                                                                            onClick={function(e) { e.preventDefault(); window.open(process.env.REACT_APP_API_URL + '/arquivo/download/' + adt.arquivo_nf_id, '_blank'); }}>
                                                                                            🧾 NF recebida — baixar
                                                                                        </a>
                                                                                    ) : (
                                                                                        <span title="Nota fiscal registrada.">🧾 NF recebida</span>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            <AdiantamentoClientePagou adiantamento={adt} perfil={perfil} />
                                                                        </td>
                                                                        <td>{adt.vencimento ? (fmtDate(adt.vencimento) || adt.vencimento) : '—'}</td>
                                                                        <td className="fin-pp__cell-strong" style={{ textAlign: 'right' }}>
                                                                            R$ {moeda(adt.valor)}
                                                                        </td>
                                                                        <td>
                                                                            {(() => {
                                                                                const acoes = [];
                                                                                if (podeRenegociar && isNaoCred && !isExcluido) {
                                                                                    acoes.push({
                                                                                        label: 'Renegociar', icon: <FaSync size={14} />, ok: true,
                                                                                        desc: 'Renegociar este adiantamento com o fornecedor',
                                                                                        onClick: function() {
                                                                                            setAbaAtiva('registrar');
                                                                                            history.push('/solicitarAdiantamento/' + orcamentoId + '?renegociar=' + adt.parcela_id + (idEvento ? '&evento=' + idEvento : ''));
                                                                                        }
                                                                                    });
                                                                                }
                                                                                if (podeRenegociar && !isExcluido && !editando) {
                                                                                    acoes.push({
                                                                                        label: 'Editar', icon: <FaPen size={14} />,
                                                                                        desc: 'Editar valor / vencimento',
                                                                                        onClick: () => abrirEdicaoAdt(adt)
                                                                                    });
                                                                                }
                                                                                if (podeAgirAdiantamento && isLiberado && !isExcluido) {
                                                                                    acoes.push({
                                                                                        label: 'Solicitar NF', icon: <FaFileInvoice size={14} />,
                                                                                        desc: 'Enviar e-mail ao fornecedor solicitando a nota fiscal',
                                                                                        onClick: () => abrirSolicitarNF(adt)
                                                                                    });
                                                                                    acoes.push({
                                                                                        label: enviandoNFUpload[adt.parcela_id] ? 'Enviando NF...' : 'Enviar NF',
                                                                                        icon: <FaUpload size={14} />,
                                                                                        desc: 'Anexar a nota fiscal diretamente (substitui a atual, se houver)',
                                                                                        disabled: !!enviandoNFUpload[adt.parcela_id],
                                                                                        onClick: () => uploadNFAdiantamento(adt)
                                                                                    });
                                                                                }
                                                                                if (podeAgirAdiantamento && !isExcluido) {
                                                                                    acoes.push({
                                                                                        label: 'Excluir', icon: <FaTrashAlt size={14} />, danger: true,
                                                                                        desc: 'Excluir pedido de adiantamento',
                                                                                        onClick: () => abrirExcluirAdiantamento(adt)
                                                                                    });
                                                                                }
                                                                                if (acoes.length === 0) return null;
                                                                                return (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="fin-pp__rowbtn"
                                                                                        title="Ações"
                                                                                        onClick={(e) => { e.stopPropagation(); setSheetAdt({ adt: adt, actions: acoes }); }}
                                                                                    >
                                                                                        <FaEllipsisV size={14} />
                                                                                    </button>
                                                                                );
                                                                            })()}
                                                                        </td>
                                                                    </tr>
                                                                ];

                                                                if (editando) {
                                                                    rows.push(
                                                                        <tr key={adt.titulo_id + '-edit'}>
                                                                            <td colSpan={6}>
                                                                                <div className="border rounded p-3" style={{ background: '#f8f9fa' }}>
                                                                                    <div className="fw-semibold small text-muted mb-2">Editar adiantamento</div>
                                                                                    <div className="row g-2 mb-2">
                                                                                        <div className="col-sm-5">
                                                                                            <FinField label="Novo valor (R$)" full>
                                                                                                <FinValor allowNegative={false}
                                                                                                    fixedDecimalScale
                                                                                                    moeda="real"
                                                                                                    value={editValor}
                                                                                                    onValueChange={({ value }) => setEditValor(value)}
                                                                                                />
                                                                                            </FinField>
                                                                                        </div>
                                                                                        <div className="col-sm-5">
                                                                                            <FinField label="Novo vencimento" full>
                                                                                                <input
                                                                                                    type="date"
                                                                                                    className="fin-pp__input"
                                                                                                    style={{ paddingLeft: 14 }}
                                                                                                    value={editVencimento}
                                                                                                    onChange={e => setEditVencimento(e.target.value)}
                                                                                                />
                                                                                            </FinField>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="mb-2">
                                                                                        <FinField label="Justificativa" full>
                                                                                            <FinTextarea
                                                                                                rows={2}
                                                                                                value={editJustificativa}
                                                                                                onChange={e => setEditJustificativa(e.target.value)}
                                                                                                placeholder="Motivo da alteração..."
                                                                                            />
                                                                                        </FinField>
                                                                                    </div>
                                                                                    <div className="d-flex gap-2">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm"
                                                                                            onClick={salvarEdicaoAdiantamento}
                                                                                            disabled={editSalvando}
                                                                                        >
                                                                                            {editSalvando ? 'Salvando...' : '💾 Salvar e Notificar Financeiro'}
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="fin-pp__btn fin-pp__btn--sm"
                                                                                            onClick={() => setEditandoParcelaId(null)}
                                                                                        >
                                                                                            Cancelar
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }

                                                                return rows;
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })()}

                {/* ── Tab 3: Recibos ────────────────────────────────────────── */}
                {abaAtiva === 'recibos' && (
                    <div className="fin-pp__card" style={{ padding: 18 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaHistory size={14} /></span>
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <span className="fin-pp__cphead-title">Histórico de Recibos</span>
                            </div>
                            {recibos.length > 0 && (
                                <span className="fin-pp__pill is-info">{recibos.length}</span>
                            )}
                        </div>
                        <div className="">
                            {recibos.length === 0 ? (
                                <div className="text-center text-muted small py-3">Nenhum recibo enviado até o momento.</div>
                            ) : (
                                <div className="d-flex flex-column gap-2 mb-4">
                                    {recibos.map((recibo, idx) => {
                                        const reciboId = recibo?.arquivo_objeto?.id || recibo?.Arquivo?.id || recibo?.arquivo;
                                        const dataRecibo = fmtDatetime(recibo?.created_at);
                                        const previsao  = fmtDate(recibo?.dataPrevisaoPagamento);
                                        return (
                                            <div key={recibo.id || idx} className="border rounded p-2" style={{ backgroundColor: '#f8f9fa', fontSize: '0.85rem' }}>
                                                <div className="d-flex justify-content-between align-items-start gap-2">
                                                    <div>
                                                        <div className="fw-semibold d-flex align-items-center gap-2">
                                                            Recibo {String(idx + 1).padStart(2, '0')}
                                                            {recibo._origem === 'financeiro' && (
                                                                <span className="badge" style={{ background: '#e8f5e9', color: '#2e7d32', fontSize: '0.68rem', padding: '2px 6px', borderRadius: '10px', fontWeight: 500 }}>
                                                                    Financeiro
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="text-muted">Valor: {moeda(recibo.valor || 0)}</div>
                                                        {dataRecibo  && <div className="text-muted">Enviado: {dataRecibo}</div>}
                                                        {previsao    && <div className="text-muted">Previsão: {previsao}</div>}
                                                        {recibo.loginSap   && <div className="text-muted">SAP: {recibo.loginSap}</div>}
                                                        {recibo.observacao && <div className="text-muted">{recibo.observacao}</div>}
                                                    </div>
                                                    {reciboId && (
                                                        <button
                                                            type="button"
                                                            className="fin-pp__btn fin-pp__btn--sm"
                                                            title="Baixar"
                                                            onClick={() => window.open(process.env.REACT_APP_API_URL + `/arquivo/download/${reciboId}`, '_blank')}
                                                        >
                                                            <FaDownload size={12} />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {recibos.length === 0 && (
                                <div className="text-muted small" style={{ fontSize: '0.8rem' }}>
                                    O upload de recibos é feito pelo Financeiro.
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* ── Action-sheet (menu ⋮) da linha de adiantamento ── */}
            {sheetAdt && (
                <div className="fin-pp fin-pp__sheet-backdrop" onClick={() => setSheetAdt(null)}>
                    <div className="fin-pp__sheet" onClick={(e) => e.stopPropagation()}>
                        <div className="fin-pp__sheet-head">
                            <span className="fin-pp__sheet-head-ic"><FaEllipsisV size={17} /></span>
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <h3 className="fin-pp__sheet-title">Ações</h3>
                                <p className="fin-pp__sheet-sub">{sheetAdt.adt.descricao} · R$ {moeda(sheetAdt.adt.valor)}</p>
                            </div>
                            <button type="button" className="fin-pp__sheet-close" onClick={() => setSheetAdt(null)}><FaTimes size={16} /></button>
                        </div>
                        <div className="fin-pp__sheet-body">
                            {sheetAdt.actions.map(function(acao, idx) {
                                return (
                                    <button
                                        key={idx}
                                        type="button"
                                        className={'fin-pp__sheet-item' + (acao.disabled ? ' is-disabled' : '')}
                                        disabled={!!acao.disabled}
                                        onClick={() => {
                                            if (acao.disabled) return;
                                            setSheetAdt(null);
                                            acao.onClick();
                                        }}
                                    >
                                        <span className={'fin-pp__sheet-item-ic' + (acao.ok ? ' is-ok' : '') + (acao.danger ? ' is-danger' : '')}>{acao.icon}</span>
                                        <span className="fin-pp__sheet-item-txt">
                                            <span className="fin-pp__sheet-item-label">{acao.label}</span>
                                            {acao.desc && <span className="fin-pp__sheet-item-desc">{acao.desc}</span>}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Solicitar NF ao Fornecedor (adiantamento creditado) ── */}
            {solicitarNFModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFileInvoice size={17} /></span>
                                <h3 className="fin-pp__modal-title">Solicitar NF ao Fornecedor
                                    <span className="fin-pp__modal-sub">{solicitarNFModal.descricao || 'Adiantamento'}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setSolicitarNFModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">
                                    Um <strong>e-mail</strong> será enviado ao fornecedor solicitando a nota fiscal deste adiantamento.
                                </p>
                                <div className="mb-2">
                                    <label className="form-label small fw-bold">
                                        E-mails para envio
                                        {solicitarNFModal.fornecedor_email && (
                                            <span className="text-muted fw-normal ms-2" style={{ fontSize: '0.78rem' }}>
                                                (pré-preenchido do cadastro do fornecedor)
                                            </span>
                                        )}
                                    </label>
                                    {emailsSolicitarNF.map(function(email, idx) {
                                        return (
                                            <div key={idx} className="d-flex gap-2 mb-2 align-items-center">
                                                <input
                                                    type="email"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14, flex: 1, minWidth: 0 }}
                                                    placeholder="email@fornecedor.com"
                                                    value={email}
                                                    onChange={function(e) {
                                                        setEmailsSolicitarNF(function(prev) {
                                                            return prev.map(function(v, i) { return i === idx ? e.target.value : v; });
                                                        });
                                                    }}
                                                />
                                                {emailsSolicitarNF.length > 1 && (
                                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                                        onClick={function() {
                                                            setEmailsSolicitarNF(function(prev) {
                                                                return prev.filter(function(_, i) { return i !== idx; });
                                                            });
                                                        }}>
                                                        <FaTimes size={12} />
                                                    </button>
                                                )}
                                            </div>
                                        );
                                    })}
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                        disabled={emailsSolicitarNF.length >= 3}
                                        onClick={function() { setEmailsSolicitarNF(function(prev) { return prev.length >= 3 ? prev : [...prev, '']; }); }}>
                                        <FaPlus size={12} /> Adicionar e-mail
                                    </button>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setSolicitarNFModal(null)}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" disabled={enviandoNF} onClick={enviarSolicitarNF}>
                                    <FaFileInvoice size={13} /> {enviandoNF ? 'Enviando...' : 'Enviar Solicitação'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Excluir pedido de adiantamento (padrão fin-pp) ── */}
            {excluirModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={(e) => { if (e.target === e.currentTarget && !excluindoAdt) setExcluirModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 480 }}>
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><FaTrashAlt size={17} /></span>
                                <h3 className="fin-pp__modal-title">Excluir pedido de adiantamento
                                    <span className="fin-pp__modal-sub">{excluirModal.descricao || 'Adiantamento'} · R$ {moeda(excluirModal.valor)}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setExcluirModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">
                                    O pedido será <strong>removido</strong> (fica registrado quem/quando)
                                    e os <strong>responsáveis do evento</strong> serão avisados por e-mail.
                                </p>
                                <div className="fin-pp__field" style={{ width: '100%' }}>
                                    <label className="fin-pp__label">Motivo (opcional)</label>
                                    <textarea className="fin-pp__input" rows={3}
                                        style={{ height: 'auto', padding: '10px 14px' }}
                                        placeholder="Ex: pedido duplicado, valor incorreto..."
                                        value={motivoExcluir}
                                        onChange={e => setMotivoExcluir(e.target.value)} />
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setExcluirModal(null)} disabled={excluindoAdt}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" disabled={excluindoAdt} onClick={confirmarExcluirAdiantamento}>
                                    <FaTrashAlt size={14} /> {excluindoAdt ? 'Excluindo...' : 'Excluir pedido'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </ErpTemplate>
    );
}
